import * as React from "react";
export const StartTime = (props) => React.createElement("div", { className: `rj-ev-list__${props.componentPrefix}__start-time` },
    React.createElement("span", { className: `rj-ev-list__${props.componentPrefix}__start` }, props.dict.StartedAt),
    React.createElement("span", { className: `rj-ev-list__${props.componentPrefix}__time` }, props.eventTime));
//# sourceMappingURL=StartTime.js.map